import { useIsClient } from '@crehana/react-hooks';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var ClientSide = function ClientSide(_ref) {
  var children = _ref.children;
  var isClient = useIsClient();
  if (!isClient || !children) {
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default ClientSide;